import ApiError from "./ApiError";

export default class SignInInvalidPasswordError extends ApiError{
}